import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { ExchangeRefundSelectControl } from '../ExchangeRefundSelectControl';
const ExchangeRefundPassengers = ({ className, passengers, onSelect }) => {
    const { ExchangeRefundPassengers: theme } = useTheme('Entities').Order;
    const onChangeSelect = (ids) => (selected) => {
        onSelect(ids, selected);
    };
    return (React.createElement("div", { className: cn(theme.passengers, className) }, passengers.map(passenger => (React.createElement(ExchangeRefundSelectControl, { key: passenger.ids.join('/'), label: passenger.label, isSelected: passenger.isSelected, isDisabled: passenger.isDisabled, onChange: onChangeSelect(passenger.ids) })))));
};
export default ExchangeRefundPassengers;
